import React, { useContext, useEffect, useState } from "react"
import { DF_MO0004Context } from "../context"
import { Modal, Row } from "reactstrap"
import TableSimple from "../../../components/Dynamic/TableSimple"
import NotificationModal from "../../../components/Common/NotificationModal"
import BizinBackend from "../../../helpers/bizin_helper"
import ModalIframePage from "../../../components/Common/ModalIframePage"
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente"
import { useDispatch } from "react-redux"
import { isLoading } from "../../../store/layout/actions"

export default function GridBody() {
  const {
    paramsOnFilter,
    triggerOnFilter,
    setTriggerOnFilter,
    inputGlobalSearchValue,
    setFilteredData,
    userProfile,
    csrfToken,
    access_token
  } = useContext(DF_MO0004Context)

  const dispatch = useDispatch(); 

  const [triggerType, setTriggerType] = useState('')
  const [openModalVisualization, setOpenModalVisualization] = useState(false)
  const [openModalDF_MO0010, setOpenModalDF_MO0010] = useState(false)
  const [openModalRecusa, setOpenModalRecusa] = useState(false)
  const [openModalConfirmAceite, setOpenModalConfirmAceite] = useState(false)
  const [openModalConfirmRecusa, setOpenModalConfirmRecusa] = useState(false)
  const [inputOperacao, setInputOperacao] = useState(false)
  const [inputJustificativa, setInputJustificativa] = useState("")

  const handleTriggers = (trigger) => {
    if(trigger?.transaction_id === 'DF_MO0010') setOpenModalDF_MO0010(true)
    else{
      setOpenModalVisualization(true)
    }
    setTriggerType(trigger)
  }

  const handleAceitePedido = async () => {
    try {
      dispatch(isLoading(true))
      await BizinBackend.executeProcedure({
        1: triggerType?.params?.split('=')[1] || null ,
        2: userProfile.ID_Usuario
      }, "FRONT_Workspace_DF_MO0010_Aceite", csrfToken, access_token)

      setOpenModalConfirmAceite(true)
      setOpenModalDF_MO0010(false)
    } catch (error) {
      console.log(error, "Ocorreu um erro ao aceitar o pedido.")
    } finally {
      dispatch(isLoading(false))
    }
  }

  const handleRecusaPedido = async () => {
    let input_operacao_value = inputOperacao.input_operacao?.value
    let input_justificativa_value = inputJustificativa
    try {
      dispatch(isLoading(true))
      await BizinBackend.executeProcedure({
        1: triggerType?.params?.split('=')[1] || null,
        2: userProfile.ID_Usuario,
        3: input_operacao_value,
        4: input_justificativa_value
      }, "FRONT_Workspace_DF_MO0010_Recusa", csrfToken, access_token)
      setOpenModalRecusa(false)
      setOpenModalConfirmRecusa(true)
    } catch (error) {
      console.log("Ocorreu um erro ao recusar o pedido", error)
    } finally {
      dispatch(isLoading(false))
    }
  }

  return (
    <React.Fragment>
      <Row>
        <TableSimple
          dataKey={"ID_Arquivo"}
          procName="FRONT_Workspace_DF_MO0004_Tabela_Grid_V16"
          procParams={`[
            ${userProfile.ID_Usuario}, 
            "pt-BR", 
            "<#Pagination_Number#>",
            "<#Registro_Pagina#>",

            "PED",
            "<#Filtro_Data_Inicio#>",
            "<#Filtro_Data_Termino#>",
            "<#Filtro_ID_Empresa_Origem#>",
            "<#Filtro_ID_Planta_Origem#>",
            "<#Filtro_ID_Empresa_Destino#>",
            "<#Filtro_ID_Planta_Destino#>",
            "<#Filtro_Numero_Documento#>",

            "<#Filtro_Status_Documento#>",
            "<#Filtro_Status_Validacao#>",
            "<#Filtro_Status_Integracao#>",
            "<#Filtro_Status_Cotacao#>",
            "<#Filtro_Status_Leitura#>",
            "<#Filtro_Status_Aceite#>",
            "<#Filtro_Status_Saldo#>",
            "<#Filtro_Status_Agendamento#>",

            "<#Filtro_ID_Categorias#>",
            "<#Filtro_Documento_Relacionado#>",
            "<#Filtro_PreFiltro#>",
            "<#Filtro_Tipo_Pedido#>"
          ]`}
          columnsList={
            [
              {
                "field":"Status",
                "header":"Status",
                "width": '5%',
                "hasImage": true,
              },
              {
                "field":"Pedido",
                "header":"Pedido",
                "sort": true
              },
              {
                "field":"Data_Documento",
                "header":"Emissão",
                "sort": true
              },
              {
                "field":"Processamento",
                "header":"Processou em",
                "sort": true
              },              
              {
                "field":"Filial_Revenda",
                "header":"Filial da Revenda",
                "hasImage": true,
                "sort": true
              },
              {
                "field":"Fornecedor",
                "header":"Fornecedor",
                "hasImage": true,
                "sort": true
              },        
              {
                "field":"Valor",
                "header":"Valor",
                "sort": true
              },
              {
                "field":"Coluna_Funcoes",
                "header":"Funções",
                "width": '5%',
                "hasImage": true,
                "Export": false
              },
              ]
          }
          paramsOnFilter={paramsOnFilter}
          triggerOnFilter={triggerOnFilter}
          setTriggerOnFilter={setTriggerOnFilter}
          inputSearchValue={inputGlobalSearchValue}
          enableDataSharing={true}
          onFilteredDataChange={setFilteredData}
          callbackTriggers={handleTriggers}
        />

        <ModalIframePage 
          triggerType={triggerType}
          openModal={openModalVisualization}
          onClosed={() => setOpenModalVisualization(!openModalVisualization)}
        />

          <Modal
            className={`modal-dinamic-table-simple`}
            isOpen={openModalRecusa}
            style={{ width: 900}}
            toggle={() => {
              setOpenModalRecusa(!openModalRecusa);
            }}
          >
            <div > 
              <div className="modal-header d-flex align-items-center justify-content-between">
                <h5
                  className="modal-title mt-0 font-size-24 font-w-600 text-color-azul1"
                  id="myModalLabel"
                >
                  Parâmetros de Aceite ou Recusa Manual
                </h5>            
                <button
                  type="button"
                  onClick={() => {
                    setOpenModalRecusa(!openModalRecusa);
                  }}
                  className="btn border-0 p-0"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="fas fa-times font-size-24 text-gray-secundary"></i>
                </button>
              </div>

              <div className="modal-body">
                  <div>
                    <TranspaleStringToComponente
                      elementId={"operacao"}
                      elementProps={{
                        value: '',
                        type: 'Combobox',
                        title: "Selecione a operação que será executada no sistema destino",
                        id: "input_operacao",
                        isDisabled: false,
                        procedure: "FRONT_Workspace_DF_MO0010_Get_Processos_Config_Dimensoes_Valores_Recusa",
                        procedureParams: []
                      }}
                      onPreFilter={(filters) => setInputOperacao(filters)} 
                    />
                  </div>
                  <div>
                    <label className="fs-6 text-color-gray-700 mb-2">
                      Justificativa da Recusa
                    </label>
                    <textarea
                      className="form-control"
                      rows={6}
                      value={inputJustificativa}
                      onChange={(e) => setInputJustificativa(e.target.value)}
                    />
                  </div>
                  <div className="mt-3 d-flex justify-content-end">
                    <button type="button" className="btn btn-primary-dark" onClick={handleRecusaPedido}>Confirmar Recusa</button>
                  </div>
              </div>          
            </div>            
          </Modal>

        <NotificationModal
          isOpen={openModalDF_MO0010}
          type="warning"
          titleCustom="Parâmetros de Aceite ou Recusa Manual"
          hasButtonCustom
          message={`O parâmetro selecionado nessa tela será para determinar o aceite ou a recusa do manual.`}
          onClose={() => setOpenModalDF_MO0010(!openModalDF_MO0010)}
        >
          <strong className="mb-3 text-center">Selecione a operação que será executada no sistema destino</strong>
          <div className="d-flex gap-3 align-items-center">
            <button type="button" className="btn btn-primary-dark" onClick={handleAceitePedido}>Aceite do Pedido</button>
            <button type="button" className="btn btn-danger" onClick={() => {
              setOpenModalDF_MO0010(false)
              setOpenModalRecusa(true)
            }}>Recusa do Pedido</button>
          </div>
        </NotificationModal>
        
        {/* Confirma aceite do Pedido */}
        <NotificationModal
          isOpen={openModalConfirmAceite}
          type="success"
          titleCustom="Sucesso!"
          message={`O Pedido foi enviado para processamento, verifique-o novamente mais tarde.`}
          onClose={() => setOpenModalConfirmAceite(!openModalConfirmAceite)}
        />

        {/* Confirma recusa do Pedido */}
        <NotificationModal
          isOpen={openModalConfirmRecusa}
          type="success"
          titleCustom="Sucesso!"
          message={`O Pedido foi recusado, verifique-o novamente mais tarde.`}
          onClose={() => setOpenModalConfirmRecusa(!openModalConfirmRecusa)}
        />
      </Row>
    </React.Fragment>
  )
}
